import { Badge } from "@exhousing/design-system";
import { Building2, User, Users } from "lucide-react";

/** Who a document is addressed to. Derived on the backend; shown wherever a document appears. */
const RECIPIENT: Record<string, { label: string; Icon: typeof User }> = {
  tenant: { label: "Tenant", Icon: User },
  landlord: { label: "Landlord", Icon: Building2 },
  both: { label: "Tenant & Landlord", Icon: Users },
};

export function RecipientChip({ recipient }: { recipient: string | null | undefined }) {
  if (!recipient) return null;
  const r = RECIPIENT[recipient];
  if (!r) return null;
  const { label, Icon } = r;
  return (
    <Badge tone="brand">
      <Icon className="size-3" />
      To: {label}
    </Badge>
  );
}
